<div class="project-right-section-title" [ngClass]="class">
  <div class="project-right-section-title__name">{{title}}</div>
  <div class="project-right-section-title__actions">
    <ng-content></ng-content>
  </div>
</div>
